export const lg_account_detail = {
  account_detail_th: {
    title: "ข้อมูลส่วนตัว",
    txt_company: "บริษัท",
    txt_name: "ชื่อ-นามสกุล",
    txt_email: "อีเมล",
    txt_birthday: "วัน-เดือน-ปี เกิด",
    txt_phone: "เบอร์โทรศัพท์",
    txt_permission: "สิทธิ์การใช้งาน",
    btn_cancel: "ยกเลิก",
    btn_edit: "แก้ไข",
  },
  account_detail_en: {
    title: "Account Information",
    txt_company: "Company",
    txt_name: "Name",
    txt_email: "Email",
    txt_birthday: "Birthday (YYYY-MM-DD)",
    txt_phone: "Phone",
    txt_permission: "Permissions",
    btn_cancel: "Cancel",
    btn_edit: "Edit",
  },
};

export const lg_account_detail_edit = {
  account_detail_th: {
    title: "แก้ไขข้อมูลส่วนตัว",
    txt_name: "ชื่อ-นามสกุล",
    txt_email: "อีเมล",
    txt_birthday: "วันเดือนปีเกิด (YYYY-MM-DD)",
    txt_phone: "เบอร์โทรศัพท์",
    btn_cancel: "ยกเลิก",
    btn_save: "บันทึก",
    dialog_select_company: "กรุณาเลือกบริษัท",
    dialog_check_data: "กรุณาตรวจสอบข้อมูล",
    dialog_check_save: "บันทึกข้อมูล",
    dialog_check_save_success: "บันทึกข้อมูลสำเร็จ",
    messageAlert: "Update ข้อมูลส่วนตัวสำเร็จ",
    oldmessageAlert: "หลังจาก Update ข้อมูลส่วนตัว ท่านควรทำการ LogOut แล้ว LogIn ใหม่",
    personal_information:"ข้อมูลส่วนตัว",
    txt_fname: "ชื่อ",
    txt_lname: "นามสกุล",
    rules_commond: "บังคับกรอกข้อมูล",
    information_updated_success:"อัปเดตข้อมูลเรียบร้อยแล้ว",
    information_updated_success_details:"ข้อมูลของคุณได้ถูกบันทึกแล้ว",
    close:"ปิด",
    something_went_wrong:"เกิดข้อผิดพลาด",
    something_went_wrong_details1:"ไม่สามารถบันทึกได้",
    something_went_wrong_details2:"กรุณาตรวจสอบข้อมูลของคุณและลองใหม่อีกครั้ง",
    txt_old_pass: "รหัสผ่านปัจจุบัน",
    enter_txt_old_pass: "กรอกข้อมูลรหัสผ่านปัจจุบัน",
    txt_new_pass: "รหัสผ่านใหม่",
    enter_txt_new_pass: "กรอกข้อมูลรหัสผ่านใหม่",
    txt_confirm_pass: "ยืนยันรหัสผ่านใหม่",
    enter_txt_confirm_pass: "กรอกข้อมูลยืนยันรหัสผ่านใหม่",
    update_password:"อัปเดตรหัสผ่าน",
    change_password:"เปลี่ยนรหัสผ่าน",
    password_update_successfully:"อัปเดตรหัสผ่านเรียบร้อยแล้ว",
    password_update_successfully_details:"รหัสผ่านของคุณได้ถูกบันทึกแล้ว",
    something_went_wrong_password_details1:"ไม่สามารถเปลี่ยนรหัสผ่านได้",
    something_went_wrong_password_details2:"กรุณาตรวจสอบรหัสผ่านเดิมและลองใหม่อีกครั้ง",
    account_status:"สถานะบัญชี",
    account_status_active:"ใช้งานอยู่",
    account_status_inactive:"ไม่ใช้งาน",
    deactivate_account:"ปิดการใช้งานบัญชี?",
    deactivate_your_account:"ปิดการใช้งานบัญชี?",
    if_you_deactivate_your_account:" เมื่อปิดการใช้งานบัญชี",
    you_will_not_be_able_to_host_or_join_meetings:"คุณจะไม่สามารถสร้างหรือเข้าร่วมการประชุมได้",
    your_profile_will_be_hidden:"โปรไฟล์ของคุณจะถูกปิดการแสดงผล",
    scheduled_meetings_will_remain_stored:"การประชุมที่กำหนดจะยังคงถูกเก็บไว้",
    data_retention:"ข้อมูลการใช้งาน/บันทึก/เอกสารที่เกี่ยวข้องจะถูกเก็บรักษาตามนโยบายการเก็บข้อมูลของเรา",
    reactivate_account:"คุณสามารถเปิดใช้งานบัญชีนี้กลับได้ด้วยการเข้าสู่ระบบ",
    permanently_delete_data:"การดำเนินการนี้ไม่ใช่การลบบัญชีถาวร",
    continue:"ดำเนินการต่อ",
      reason_title: "เหตุผลที่ปิดบัญชี (ไม่บังคับ)",
      reason_break: "พักการใช้งานชั่วคราว",
      reason_privacy: "กังวลเรื่องความเป็นส่วนตัว",
      reason_expensive: "ราคาไม่เหมาะสม",
      reason_alternative: "เจอแพลตฟอร์มอื่นที่เหมาะกว่า",
      reason_technical: "มีปัญหาทางเทคนิค",
      reason_other: "อื่นๆ",
      skip: "ข้าม",
      confirm_password_title: "เพื่อความปลอดภัย กรุณากรอกรหัสผ่านเพื่อยืนยันการปิดการใช้งานบัญชี",
      password: "รหัสผ่าน",
      confirm_deactivation: "ยืนยันการปิดใช้งาน",
      deactivate_success: "ปิดการใช้งานบัญชีเรียบร้อยแล้ว",
      delete_notice: "บัญชีของคุณจะถูกลบถาวรภายในระยะเวลา 30 วัน",
      reactivate_notice: "คุณสามารถเปิดใช้งานบัญชีอีกครั้งได้ทุกเมื่อภายในระยะเวลา 30 วัน เพียงเข้าสู่ระบบแล้วข้อมูลของคุณจะไม่ถูกลบ",
      contact: "หากมีข้อสงสัย กรุณาติดต่อที่ contact@dcm.co.th",
      back_home: "กลับสู่หน้าหลัก",
      account_deactivated: "บัญชีของคุณถูกปิดการใช้งานอยู่",
      reactivate_question: "ต้องการเปิดใช้งานบัญชีนี้ใช่หรือไม่?",
      reactivate: "เปิดใช้งานบัญชี",
      logout: "ออกจากระบบ",
      password_incorrect: "รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่",
      new_password_must_contain: "รหัสผ่านใหม่จะต้องมี"
  },
  account_detail_en: {
    title: "Edit Account Information",
    txt_name: "Name",
    txt_email: "Email",
    txt_birthday: "Date of Birth (YYYY-MM-DD)",
    txt_phone: "Phone",
    btn_cancel: "Cancel",
    btn_save: "Save Changes",
    dialog_select_company: "Please select a company",
    dialog_check_data: "Please check your information",
    dialog_check_save: "Save",
    dialog_check_save_success: "Save successful",
    messageAlert: "Update successful",
    oldmessageAlert: "After updating the account information, you must logout and login again",
    personal_information:"Personal Information",
    txt_fname: "First Name",
    txt_lname: "Last Name",
    rules_commond: "This is required",
    information_updated_success:"Information updated successfully",
    information_updated_success_details:"Your changes have been saved. ",
    close:"Close",
    something_went_wrong:"Something went wrong",
    something_went_wrong_details1:"We couldn’t update your information.",
    something_went_wrong_details2:"Please check your details and try again.",
    txt_old_pass: "Current Password",
    enter_txt_old_pass: "Enter current password",
    txt_new_pass: "New Password",
    enter_txt_new_pass: "Enter new password",
    txt_confirm_pass: "Confirm New Password",
    enter_txt_confirm_pass: "Enter confirm password",
    update_password:"Update Password",
    change_password:"Change Password",
    password_update_successfully:"Password update successfully",
    password_update_successfully_details:"Your password have been changed.",
    something_went_wrong_password_details1:"We couldn’t update your password.",
    something_went_wrong_password_details2:"Please check your current password and try again.",
    account_status:"Account Status",
    account_status_active:"Active",
    account_status_inactive:"Inactive",
    deactivate_account:"Deactivate Account?",
    deactivate_your_account:"Deactivate Your Account?",
    if_you_deactivate_your_account:"If you deactivate your account",
    you_will_not_be_able_to_host_or_join_meetings:"You will not be able to host or join meetings",
    your_profile_will_be_hidden:"Your profile will be hidden",
    scheduled_meetings_will_remain_stored:"Scheduled meetings will remain stored",
    data_retention:"Meeting recordings and minutes will be retained according to our data retention policy",
    reactivate_account:"You can reactivate your account at any time by logging in again",
    permanently_delete_data:"This action does NOT permanently delete your data.",
    continue:"Continue",
      reason_title: "Why are you leaving? (Optional)",
      reason_break: "Just taking a break",
      reason_privacy: "Privacy concerns",
      reason_expensive: "Too expensive",
      reason_alternative: "Found alternative platform",
      reason_technical: "Technical issues",
      reason_other: "Other",
      skip: "Skip",
      confirm_password_title: "For security purposes, please confirm your password.",
      password: "Password",
      confirm_deactivation: "Confirm Deactivation",
      deactivate_success: "Your account has been deactivated.",
      delete_notice: "Your account will be permanently deleted after 30 days.",
      reactivate_notice: "You may reactivate your account at any time within this 30-day period by simply logging in. If you do so, no data will be deleted.",
      contact: "If you have any questions, please contact us at contact@dcm.co.th.",
      back_home: "Back to Homepage",
      account_deactivated: "Your account is currently deactivated.",
      reactivate_question: "Would you like to reactivate it?",
      reactivate: "Reactivate",
      logout: "Logout",
      password_incorrect: "Password is incorrect. Please try again.",
      new_password_must_contain: "New Password must contain"
  },
};
